import { render, staticRenderFns } from "./SendConfirm.vue?vue&type=template&id=4b19e8a8"
import script from "./SendConfirm.vue?vue&type=script&lang=js"
export * from "./SendConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports